import AspectRatio from '@/shared/AspectRatio/AspectRatio';
import styled from 'styled-components';

export const StyledVideoActivity = styled(AspectRatio)`
  width: 100%;
  margin: 0 auto;
  @media screen and (min-aspect-ratio: 3) {
    height: 90vh;
    width: initial;
  }
`;
